import React from 'react';
import { Sparkles } from 'lucide-react';

const Integrations = () => {
  const integrations = [
    {
      name: 'Salesforce',
      logo: 'https://www.salesforce.com/content/dam/sfdc-docs/www/logos/logo-salesforce.svg',
      description: 'Connect with Salesforce CRM to sync customer data and interactions',
      status: 'available',
      category: 'CRM'
    },
    {
      name: 'GoHighLevel',
      logo: '/integrations/ghl-logo.png',
      description: 'Integrate with GoHighLevel marketing automation platform',
      status: 'available',
      category: 'Marketing'
    },
    {
      name: 'RingCentral',
      logo: 'https://www.ringcentral.com/favicon.ico',
      description: 'Seamless integration with RingCentral phone systems',
      status: 'available',
      category: 'Telephony'
    },
    {
      name: 'NICE',
      logo: 'https://www.nice.com/favicon.ico',
      description: 'Connect with NICE contact center solutions',
      status: 'available',
      category: 'Contact Center'
    },
    {
      name: 'CISCO',
      logo: 'https://www.cisco.com/favicon.ico',
      description: 'Integrate with Cisco collaboration and communication tools',
      status: 'available',
      category: 'Telephony'
    },
    {
      name: 'HubSpot',
      logo: 'https://www.hubspot.com/favicon.ico',
      description: 'Sync with HubSpot CRM and marketing automation',
      status: 'available',
      category: 'CRM'
    },
    {
      name: 'Zoho CRM',
      logo: 'https://www.zoho.com/favicon.ico',
      description: 'Connect with Zoho CRM for comprehensive customer management',
      status: 'available',
      category: 'CRM'
    }
  ];

  const categories = [...new Set(integrations.map(int => int.category))];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-foreground mb-2 flex items-center gap-3">
          <Sparkles className="w-8 h-8 text-primary" />
          Integrations
        </h1>
        <p className="text-muted-foreground">
          Connect BrainCX AI with your favorite business tools and platforms
        </p>
      </div>

      {/* Integration Partners */}
      <div className="space-y-6">
        

        {/* Group by Category */}
        {categories.map((category) => {
          const categoryIntegrations = integrations.filter(int => int.category === category);
          
          return (
            <div key={category} className="space-y-4">
              <h3 className="text-lg font-medium text-foreground flex items-center gap-2">
                <div className="w-1 h-6 bg-primary rounded-full"></div>
                {category}
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {categoryIntegrations.map((integration) => (
                  <div
                    key={integration.name}
                    className="group relative overflow-hidden bg-card/80 backdrop-blur-sm border border-border/50 rounded-xl p-6 hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300"
                  >
                    {/* Status Badge */}
                    <div className="absolute top-4 right-4">
                      <div className="flex items-center gap-1.5 px-2.5 py-1 bg-primary/10 rounded-full border border-primary/20">
                        <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
                        <span className="text-xs font-medium text-primary capitalize">{integration.status}</span>
                      </div>
                    </div>

                    {/* Logo */}
                    <div className="mb-4">
                      <div className="w-16 h-16 bg-background/50 rounded-lg border border-border/50 flex items-center justify-center overflow-hidden group-hover:border-primary/30 transition-colors">
                        {integration.logo ? (
                          <img
                            src={integration.logo}
                            alt={`${integration.name} logo`}
                            className="w-12 h-12 object-contain"
                            onError={(e) => {
                              // Fallback to text if image fails
                              e.target.style.display = 'none';
                              const fallback = e.target.parentElement.querySelector('.logo-fallback');
                              if (fallback) fallback.style.display = 'flex';
                            }}
                          />
                        ) : null}
                        <div className="logo-fallback hidden w-full h-full items-center justify-center text-2xl font-bold text-primary">
                          {integration.name.charAt(0)}
                        </div>
                      </div>
                    </div>

                    {/* Name */}
                    <h4 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                      {integration.name}
                    </h4>

                    {/* Description */}
                    <p className="text-sm text-muted-foreground line-clamp-2">
                      {integration.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {/* Coming Soon Section */}
      <div className="mt-8 bg-muted/30 border border-border/50 rounded-xl p-6">
        <div className="flex items-start gap-4">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Sparkles className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-1">More Integrations Coming Soon</h3>
            <p className="text-sm text-muted-foreground">
              We're constantly adding new integrations to expand your capabilities. 
              
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integrations;

